import { cva, type VariantProps } from "class-variance-authority";
import { forwardRef, type LabelHTMLAttributes } from "react";

const labelVariants = cva("ml-1", {
  variants: {
    size: {
      sm: "text-button-xs",
      md: "text-button-sm",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

type LabelProps = LabelHTMLAttributes<HTMLLabelElement> &
  VariantProps<typeof labelVariants>;

const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, size, htmlFor, children, ...props }, ref) => (
    <label
      htmlFor={htmlFor}
      ref={ref}
      className={labelVariants({ size, className })}
      {...props}
    >
      {children}
    </label>
  ),
);

Label.displayName = "Label";

export default Label;
